import { useMutation } from "@tanstack/react-query";
import Cookies from "js-cookie";
import config from "./config";
import { ResponseError } from "./types/responseError";

export type AgreementType = "bd" | "ta";

export interface AcceptAgreementPayload {
  type: AgreementType;
}

const baseUrl = `${config.SID_GW_BASE_URL}/v1/investor`;

export const useAcceptAgreementMutation = () =>
  useMutation<void, ResponseError, AcceptAgreementPayload>({
    mutationFn: async ({ type }) => {
      const response = await fetch(`${baseUrl}/agreements`, {
        credentials: "include",
        headers: {
          Authorization: Cookies.get("auth-token") ?? "",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ type }),
      });

      if (!response.ok) {
        console.error(await response.text());
        throw new ResponseError("Error accepting agreement", response);
      }
    },
  });
